<template>
  <td v-if="day.type == 'next'" tabindex="0" role="gridcell" :aria-label="full_date(day.date)"
    class="border-r-2 p-color last-td-background shadow-lg pb-16 td-width align-top relative box-hover focus:ring-2 focus:ring-[#38558e] outline-none">
    <div class="flex lg:flex-nowrap pl-2 py-2">
      <div class="week-cycle-fontsize week-cycle-color font-bold pr-6">
        {{ day.date }}
      </div>
      <MenuDay :day="day" :menuCycle="menuCycle" :searchForm="searchForm" :index="index" :cal_days="cal_days"
        @copyData="copyData" :copiedDataId="copiedDataId"
        :isPastDate="(moment().isBefore(day.date) === true) || (moment().format('MM-DD-YYYY') === day.date)"
        :isHoliDay="verifyExcludeDay(day.date) === false"
        if="(((moment().isBefore(day.date) === true) || (moment().format('MM-DD-YYYY') === day.date)) && verifyExcludeDay(day.date) === false)"
        @loadCalendar="loadCalendar" :week="week" @loadExcludedDateDataOnLoad="loadExcludedDateDataOnLoad"
        v-if="isMenuPlanner" />

    </div>
    <div v-if="products.length == 0 && verifyExcludeDay(day.date) === false"
      class="flex justify-center flex-col items-center w-full -ml-2 mt-5">
      <!-- <img src="/vendor/nutristudents/image/not-in-session.png" alt=""> -->
      <span class="italic text-xs mt-1">Not Available!</span>
    </div>
    <div class="color-24 text-sm block pl-2"
      v-if="products.length > 0 && isShowMenu(day) && verifyExcludeDay(day.date) === false">
    <ul>
      <li v-for="product in products">{{ getOptionName(product) }}</li>
    </ul>
    </div>

    <span v-if="verifyExcludeDay(day.date) === true"
      class="italic text-xs mb-1 bottom-0.5 left-0 right-0 absolute m-auto text-center">Not in session!</span>
  </td>


  <td v-else class="border-r-2 p-color shadow-lg pb-16 td-width align-top relative box-hover focus:ring-2 focus:ring-[#38558e] outline-none"
    :class="(((moment().isBefore(day.date) === false) && (moment().format('MM-DD-YYYY') != day.date)) || verifyExcludeDay(day.date) === true) ? 'bg-grey' : 'bg-white'"
    tabindex="0" role="gridcell" :aria-label="full_date(day.date)">
    <div class="flex lg:flex-nowrap pl-2 py-2">
      <div class="week-cycle-fontsize week-cycle-color font-bold pr-6">
        {{ day.date }} &nbsp;
        <span v-if="cal_days" class="h-2 w-2 rounded-full inline-block"
          :class="(cal_days && (cal_days.is_guidline && cal_days.is_additional)) ? 'online-background-color' : 'offline-background-color'"></span>
      </div>
      <MenuDay :day="day" :menuCycle="menuCycle" :searchForm="searchForm" :index="index" :cal_days="cal_days"
        @copyData="copyData" :copiedDataId="copiedDataId"
        :isPastDate="(moment().isBefore(day.date) === true) || (moment().format('MM-DD-YYYY') === day.date)"
        :isHoliDay="verifyExcludeDay(day.date) === false"
        if="(((moment().isBefore(day.date) === true) && (moment().format('MM-DD-YYYY') === day.date)) && verifyExcludeDay(day.date) === false )"
        @loadCalendar="loadCalendar" :week="week" @loadExcludedDateDataOnLoad="loadExcludedDateDataOnLoad"
        :is_assembly_instructions="is_assembly_instructions" v-if="isMenuPlanner" />

    </div>

    <div v-if="verifyExcludeDay(day.date) === false && isShowMenu(day)" class="color-24 text-sm block pl-2">
    <ul>
      <li v-for="product in products"> {{ getOptionName(product) }}
        <span class="float-right pr-2" v-if="searchForm.type != 'group'">{{ getOptionStudentCount(product) }}</span>
      </li>
    </ul>
    </div>


    <div class="w-full absolute button-none bottom-0-space" v-if="$page.props.isUserSuperAdmin && menuCycle && cal_days">
      <AddToFoodOrder
        v-if="!checkAlreadyAddedToCart(day.date) && ((moment().isBefore(day.date) === true) || (moment().format('MM-DD-YYYY') === day.date))"
        :searchForm="searchForm" :day="day.date" :cal_days="cal_days"
        @loadAlreadyAddedCartData="loadAlreadyAddedCartData" />
      <!-- <RemoveFromFoodOrder v-if="day.remove_food_order"  /> -->
      <RemoveFromFoodOrder v-if="checkAlreadyAddedToCart(day.date) && !showCartIcon" :cartId="cart_id_for_remove"
        @loadAlreadyAddedCartData="loadAlreadyAddedCartData" />
    </div>
    <FoodOrderCartIcon v-if="showCartIcon" />
    <span v-if="verifyExcludeDay(day.date) === true"
      class="italic text-xs mb-1 bottom-0.5 left-0 right-0 absolute m-auto text-center">Not in session!</span>
  </td>
</template>

<script>
import AddToFoodOrder from "@/Pages/Calendar/AddToFoodOrder";
import RemoveFromFoodOrder from "@/Pages/Calendar/RemoveFromFoodOrder";
import FoodOrderCartIcon from "@/Pages/Calendar/FoodOrderCartIcon";
import MenuDay from "@/Pages/Calendar/MenuDay";
var moment = require('moment');

export default {
  props: ['day', 'index', 'menuCycle', 'searchForm', 'copyData', 'copiedDataId', 'week', 'excludeDays', 'isMenuPlanner', 'alreadyAddedCartData'],
  components: {
    AddToFoodOrder,
    RemoveFromFoodOrder,
    FoodOrderCartIcon,
    MenuDay
  },



  data() {
    return {
      log: console.log,
      cal_days: null,
      moment: moment,
      is_assembly_instructions: false,
      cart_id_for_remove: '',
      showCartIcon: false
    }
  },
  computed: {
    products: function () {
      this.cal_days = null;
      let $this = this;
      if (this.menuCycle) {
        let options = [];
        this.menuCycle.menu_cycle_days.forEach(mcdays => {
          if (mcdays.day_of_week_number - 1 == $this.index) {
            $this.is_assembly_instructions = mcdays.is_assembly_instructions;
            options = mcdays.options;
            $this.cal_days = mcdays;
          }
        });
        // console.log("products options", options);
        // let a= _.orderBy(options, 'name', 'asc');
        // a= _.orderBy(a, 'category_sort', 'asc');
        return options;
      } else {
        $this.is_assembly_instructions = false;
        return [];
      }
    },



    // checkAlreadyAddedToCart(current_date) {
    //     var new_date = moment(current_date).format('YYYY-MM-DD');
    //     const exists = this.alreadyAddedCartDataa.some(
    //     (item) => item.order_date === new_date
    //     );
    //     console.log(`Value "${new_date}" exists in parent array: ${exists}`);

    // },

  },
  methods: {


    checkAlreadyAddedToCart(current_date) {
      var new_date = moment(current_date).format('YYYY-MM-DD');
      var alreadyAdd = Array.isArray(this.alreadyAddedCartData)
  ? this.alreadyAddedCartData.find(e => e.order_date === new_date)
  : null;
      if (alreadyAdd) {
        var cartId = alreadyAdd.id;
        var cartStatus = alreadyAdd.status;

        if (cartStatus == 'completed') {
          this.showCartIcon = true;
        } else {
          this.showCartIcon = false;
        }
        this.cart_id_for_remove = cartId;
        return true;
      } else {
        return false;
      }

    },

    copyData(id) {
      this.$emit('copyData', id);
    },
    getOptionName(mc) {


      if (mc.name == '') {
        return "Option " + mc.sort_order;
      } else {
        return mc.name;
      }
    },
    loadCalendar() {
      this.$emit('loadCalendar');
    },
    loadExcludedDateDataOnLoad(site, guide_line_id) {
      this.$emit('loadExcludedDateDataOnLoad', site, guide_line_id);
    },
    getOptionStudentCount(e) {
      let sc = 0;

      e.menu_cycle_day_option_components.forEach(el => {
        if (el.student_count) {
          if (sc < el.student_count)
            sc = el.student_count;
          // sc.push(el.student_count);
        }
      });
      return sc;
    },
    verifyExcludeDay(current_date) {
      // console.log('excludeDays');
      if (this.excludeDays) {
        var new_date = moment(current_date, 'MM-DD-YYYY').format('MM/DD/YYYY');
        // var new_date = moment(current_date).format('MM/DD/YYYY');
        let obj = this.excludeDays.find(o => o.date === new_date);
        if (obj) {
          return true;
        } else {
          return false;
        }
      }
      return false;

    },
    loadAlreadyAddedCartData() {
      this.$emit('loadAlreadyAddedCartData');
    },




    isShowMenu(cday) {
      return true;
      // if(cday.type == 'next')
      // {
      //   return false;
      // } else {
      //   return true;
      // }
    },

    full_date(value) {
      if (value) {
        return moment(value, 'MM-DD-YYYY').format('dddd, MMMM D, YYYY');
      }
    }


  }
};
</script>
<style scoped>
/* .button-none{
bottom: -100%;
z-index: 10;
} */

/* .box-hover{
overflow: hidden;
} */
/* .box-hover:hover .button-none{
bottom: 0;
} */

.bottom-0-space {
  bottom: 6px;
}
</style>
